import ReactDOM from 'react-dom';
import { useState, useEffect } from '@wordpress/element';
import PricingModal from './components/pricing-modal';

const mountNodeId = 'jkit-global-pricing-modal-root';

const ModalHost = () => {
    const [modalState, setModalState] = useState({ isOpen: false, context: null });

    useEffect(() => {
        // expose open/close to window for non-React callers
        window.JkitOpenPricingModal = (context = null) => setModalState({ isOpen: true, context });
        window.JkitClosePricingModal = () => setModalState({ isOpen: false, context: null });
        return () => {
            try { delete window.JkitOpenPricingModal; } catch (e) {}
            try { delete window.JkitClosePricingModal; } catch (e) {}
        };
    }, []);

    return <PricingModal isOpen={modalState.isOpen} context={modalState.context} onClose={() => setModalState({ isOpen: false, context: null })} />;
};

const mount = () => {
    if (typeof document === 'undefined') return;
    let root = document.getElementById(mountNodeId);
    if (!root) {
        root = document.createElement('div');
        root.id = mountNodeId;
        document.body.appendChild(root);
    }

    // Use createRoot when available (React 18+), fall back to legacy render.
    // Prefer React 18 createRoot if it's available on the ReactDOM global.
    try {
        if (ReactDOM && typeof ReactDOM.createRoot === 'function') {
            // Reuse existing root if previously created to avoid React warning
            // about calling createRoot on the same container multiple times.
            if (root.__jkit_react_root) {
                try {
                    root.__jkit_react_root.render(<ModalHost />);
                    return;
                } catch (e) {
                    // fall through to recreate
                }
            }

            const r = ReactDOM.createRoot(root);
            // store the root for future reuse
            try { root.__jkit_react_root = r; } catch (e) { /* ignore */ }
            r.render(<ModalHost />);
            return;
        } else {
            ReactDOM.render(<ModalHost />, root);
        }
    } catch (e) {
        ReactDOM.render(<ModalHost />, root);
    }
};

if (typeof window !== 'undefined') {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        mount();
    } else {
        window.addEventListener('load', mount);
    }
}

export default {};
